import {status} from '../../../../utils/constant';

/*
{
"id": 12345,
"status": "PENDING",
"userId": "ab123-cd456-ef789-gh753",
"userFullname": "John Doe",
"invitedOrganisationCountry": "FRANCE",
"invitedOrganisationName": "ALG",
"invitedRegistrationNumber": "123456789",
"invitedVATIdentificationNumber": "FR123456789",
"invitedContactFirstName": "John",
"invitedContactLastName": "Doe",
"invitedContactEmail": "john.doe@alg.fr",
"invitedContactPhoneNumber": "+33607080910",
"invitedContactLanguage": "fr",
"customMessage": "Hello world",
"lastSentDate": "1970-07-07T12:59:00Z",
"rejectionReason": "I don't this organisation",
"resendReason": "Pretty please",
"resendable": false,
"organisationTargetId": 654321,
"token": "jsvksjgvesgegsvugksgvlgkvjsgvkguvsv",
"creationDate": "1970-01-01T12:59:00Z",
"organisationSourceId": "789456",
"emitterOrganisationId": "456789",
"emitterOrganisationInterventionId": 741852,
"project":
{
"projectId": 852963,
"sourceRole": "CLIENT",
"targetRole": "SERVICE_PROVIDER",
"projectName": "Empire State Building"
},
"invitationType": "PROJECT",
"additionalInformation": "Used for access code invitation",
"tenderReference": "tenderReference456789",
"accessCode": "accessCode123456"
},

*/
export const invitationsInDb = [
  {
    id: 12345,
    organisationSourceId: '789456',
    userId: 'ab123-cd456-ef789-gh753',
    userFullname: 'John Doe',
    invitedOrganisationName: 'ALG',
    invitedContactEmail: 'john.doe@alg.fr',
    invitedContactFirstName: 'John',
    invitedContactLastName: 'Doe',
    customMessage: 'Hello world',
    emitterOrganisationId: '456789',
    status: status.PENDING,
    invitedContactLanguage: 'fr',
    creationDate: '1970-01-01T12:59:00Z',
    lastSentDate: '1970-07-07T12:59:00Z',
    token: 'jsvksjgvesgegsvugksgvlgkvjsgvkguvsv',
    resendable: false,
    invitationType: 'PROJECT',
    project: {
      projectId: 852963,
      sourceRole: 'CLIENT',
      targetRole: 'SERVICE_PROVIDER',
      projectName: 'Empire State Building'
    },
    rejectionReason: "I don't know this organisation",
    accessCode: 'accessCode123456',

    invitedOrganisationCountry: 'FRANCE',
    invitedRegistrationNumber: '123456789',
    invitedVATIdentificationNumber: 'FR123456789',
    invitedContactPhoneNumber: '+33607080910',
    resendReason: 'Pretty please',
    organisationTargetId: 654321,
    emitterOrganisationInterventionId: 741852,
    additionalInformation: 'Used for access code invitation',
    tenderReference: 'tenderReference456789'
  }
];
